<template>
  <div class="content">
    <column-title title="News&Events"></column-title>
    <el-timeline class="event">
      <el-timeline-item v-for="(event,index) in events" :key="index" :timestamp="event.time"
                        placement="top">
        <p>{{ event.event }}</p>
      </el-timeline-item>
    </el-timeline>
    <el-backtop target=".scrollbar .el-scrollbar__wrap" bottom="200"></el-backtop>
  </div>
</template>

<script>

import events from '@/assets/data/event.js';
import ColumnTitle from "@/components/ColumnTitle";

export default {
  name: "News",
  components: {ColumnTitle},
  data() {
    return {
      events: events
    }
  }
}
</script>

<style scoped>
.content {
  width: 80%;
  margin: auto;
}

.event {
  font-size: 16px;
}
</style>